import React, { useEffect } from "react";
import { useQuery } from "@apollo/client";
import withStyles from '@mui/styles/withStyles';
import Box from "@mui/material/Box";
import { GET_COURSE_QUERY } from "../../queries/queries";
import Lection from "./lection";
import BlueBoxArrow from "../shared/BlueBoxArrow";
import Loading from "../loading";
import Error from "../error";
import useMakeScrollable from "../../custom_hooks/make-scrollable";
import { createStyles } from "@mui/styles";

const styles = (theme) => createStyles({
  root: {
    position: "relative",
    height: 700,
    marginBottom: "60px",
  },
});

const Lections = ({
  match: {
    params: { courseId },
  },
  classes,
}) => {
  useMakeScrollable()
  useEffect(() => {
    const wrapper = document.querySelector(".scrollable");
    if (!wrapper) return;

    document.querySelector(".scrollable").addEventListener(
      "touchmove",
      function(event) {
        event.stopPropagation();
      },
      false
    );
  });
  const { loading, error, data } = useQuery(GET_COURSE_QUERY, {
    fetchPolicy: "no-cache",
    variables: { id: courseId },
  });

  if (loading) return <Loading />;
  if (error) return <Error />;

  const course = data.course;
  const routeBack = "/courses";
  return (
    <div className="scrollable">
      <Box data-testid="lections">
        <BlueBoxArrow route={routeBack} text={course.name} />
        {// @ts-expect-error
        <Box name="Lections" className={classes.root}>
          {course.sections.map((lection, index) => (
            <Lection
              key={lection.id}
              index={index}
              lection={lection}
            />
          ))}
        </Box>
        }
      </Box>
    </div>
  );
};

export default withStyles(styles)(Lections);
